import { z } from 'zod';

export const TriggerFindingChainingReplayRequestSchema = z.object({
  applicationId: z.string(),
  limit: z.int().min(1).max(50).optional().default(5),
});

export const TriggerExternalNetworkFindingChainingReplayRequestSchema =
  z.object({
    externalNetworkId: z.string(),
    limit: z.int().min(1).max(50).optional().default(5),
  });

export const TriggerFindingChainingReplayResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  findingCount: z.number(),
  findingIds: z.array(z.string()),
});
